import {
  PO_BUYER_DETAILS,
  PO_GRAPH_DATA,
  PO_REPORT_DOWNLOAD,
  PO_TABLE_DATA,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

export const getBuyerDetails = (division, department, page, limit, search) => {
  const requestURL = PO_BUYER_DETAILS;
  let obj = {};

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (search) {
    obj["search"] = search;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getGraphData = (
  date,
  aggr,
  countColumn,
  division,
  department,
  buyer,
  location,
  page,
  limit,
  showBOParts,
  fromDate
) => {
  const requestURL = PO_GRAPH_DATA;
  let obj = {
    date: date,
    aggregate_column: aggr,
    // count_column: countColumn,
    bo_parts: showBOParts,
  };

  if (countColumn && countColumn.length) {
    obj["count_column"] = countColumn.join(",");
  }

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (buyer && buyer.length) {
    obj["buyer_list"] = buyer.join(",");
  }

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  if (fromDate) {
    obj["from_date"] = fromDate;
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getPOReport = (
  date,
  division,
  department,
  buyer,
  location,
  showBOParts,
  fromDate,
  countColumn
) => {
  const requestURL = PO_REPORT_DOWNLOAD;
  let obj = {
    date: date,
    bo_parts: showBOParts,
    from_date: fromDate,
    // count_column: countColumn,
  };

  if (countColumn && countColumn.length) {
    obj["count_column"] = countColumn.join(",");
  }

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (buyer && buyer.length) {
    obj["buyer_list"] = buyer.join(",");
  }

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getPOTableData = (
  date,
  division,
  department,
  buyer,
  location,
  page,
  limit,
  showBOParts,
  fromDate,
  countColumn
) => {
  const requestURL = PO_TABLE_DATA;
  let obj = {
    date: date,
    bo_parts: showBOParts,
    from_date: fromDate,
    // count_column: countColumn,
  };

  if (countColumn && countColumn.length) {
    obj["count_column"] = countColumn.join(",");
  }

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (buyer && buyer.length) {
    obj["buyer_list"] = buyer.join(",");
  }

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
